import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { DESTINATIONS_SERVICE_KEY } from './destinationsEnum.js';

export default getActionTypesForService(DESTINATIONS_SERVICE_KEY);
